type QueryValue = string | number | boolean | null | undefined;

export function mergeHashSearchParams(
  newParams: Record<string, QueryValue> = {},
  hash: string = window.location.hash
): string {
  const cleanHash = hash.startsWith('#') ? hash.slice(1) : hash;

  const [, search = ''] = cleanHash.split('?');

  const currentParams = new URLSearchParams(search);

  Object.entries(newParams).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      currentParams.delete(key);
    } else {
      currentParams.set(key, String(value));
    }
  });

  return currentParams.toString();
}
